module.exports = __webpack_public_path__ + "static/img/news-head-bg.b2b1e9f3.png";